import React, { useState } from 'react';
import cn from 'classnames';
import style from './services-mobile.mod.scss';
import Heading from '../heading/heading';
import Text from '../text/text';
import Container from '../layout/container/container';
import Divider from '../divider/divider';
import Button from '../button/button';
import Spacing from '../layout/spacing/spacing';
import { Collapse } from '@mui/material';

const ServicesMobile = ({
  heading,
  text,
  headingSize,
  side = 'left',
  services,
  anchor = false,
}) => {
  const [activeService, setActiveService] = useState(services[0]);

  const classes = cn(style.services, {
    [style[`services--right`]]: side === 'right',
  });

  const handleServiceChange = (service) => {
    setActiveService(service);
  };

  return (
    <div id={anchor ? anchor : null}>
      <Container size="xl">
        <Divider />
        <div className={classes}>
          <div className={style.services__heading}>
            <Heading text={heading} tag={2} size={headingSize} />
          </div>
          <div className={style.services__switcher}>
            <div className={style.services__titles}>
              {services.map((service, index) => (
                <AccordionItem {...service} className={'item'} />
              ))}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ServicesMobile;

const AccordionItem = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const classes = cn(style.collapse, {
    [style[`collapse--open`]]: isOpen,
  });

  return (
    <div className={classes}>
      <div
        className={style.collapse__heading}
        onClick={() => setIsOpen(!isOpen)}
      >
        {props.title}
        {isOpen ? <MinusIcon /> : <PlusIcon />}
      </div>
      <Collapse in={isOpen}>
        <div>
          <Spacing pb={1} pt={2} />
          <Text html={props.paragraphText} />
        </div>
      </Collapse>
    </div>
  );
};

const PlusIcon = () => (
  <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path stroke="#fff" d="M11.5 0v22M22 11.5H0" />
  </svg>
);

const MinusIcon = () => (
  <svg viewBox="0 0 22 1" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path stroke="#fff" d="M22 .5H0" />
  </svg>
);
